import React from 'react';
import { Modal, Typography, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;
const { Text } = Typography;

/**
 * Form geri yükleme onay modalı
 */
export const RestoreConfirmModal = ({ onConfirm, formTitle }) => {
  const showConfirm = () => {
    confirm({
      title: 'Formu Geri Yükle',
      icon: <ExclamationCircleOutlined />,
      content: (
        <Space direction="vertical">
          <Text>Bu formu geri yüklemek istediğinizden emin misiniz?</Text>
          <Text strong>Form: {formTitle}</Text>
          <Text type="secondary">Form aktif forma dönüştürülecek.</Text>
        </Space>
      ),
      okText: 'Geri Yükle',
      cancelText: 'İptal',
      onOk: onConfirm,
    });
  };

  return { showConfirm };
};

/**
 * Form kalıcı silme onay modalı
 */
export const DeleteConfirmModal = ({ onConfirm, formTitle }) => {
  const showConfirm = () => {
    confirm({
      title: 'Formu Kalıcı Olarak Sil',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <Space direction="vertical">
          <Text>Bu formu kalıcı olarak silmek istediğinizden emin misiniz?</Text>
          <Text strong>Form: {formTitle}</Text>
          <Text type="danger" strong>
            Bu işlem geri alınamaz!
          </Text>
        </Space>
      ),
      okText: 'Kalıcı Olarak Sil',
      cancelText: 'İptal',
      okType: 'danger',
      onOk: onConfirm,
    });
  };

  return { showConfirm };
};
